import { Component, Input } from '@angular/core';
import { Documentation } from '@src/app/model/documentation';
import { take } from 'rxjs/operators';
import { ApolloService } from '@src/app/services/apollo/apollo.service';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrl: './documentation.component.scss',
  standalone: false,
})
export class DocumentationComponent {
  @Input({ required: true }) public documentation: Documentation;

  public isEditing: boolean = false; // Whether the input field is active

  public placeholderTranslationKey: string = 'formModal.noText'; // Placeholder when no text is set

  constructor(
    private _apolloService: ApolloService,
  ) {
  }

  enableEdit() {
    this.isEditing = true;
  }

  submitComment() {
    this._apolloService.updateDocumentation$(this.documentation).pipe(take(1)).subscribe(
      _ => this.isEditing = false
    );
  }
}
